export default '1, 3, 5-10';